<template>
  <UIDialog
    :is-open
    :title="dialogTitle"
    :z-index
    size="md"
    @close="handleClose"
  >
    <AssetForm
      :instance="modal.entity"
      toggled-e-o-d
      :hide-e-o-d-search
      :equalize-ticker
      @close="handleClose"
    />
  </UIDialog>
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'

import { AssetClass } from '..'
import { ModalClass } from '@types'

import { ASSET_MODAL_TITLE, ASSET_MODAL_TITLE_NEW } from './utils/const'

import { UIDialog } from '@ui/modals'
import AssetForm from './AssetForm.vue'

type Props = {
  modal: ModalClass<AssetClass>
  restrictions?: string[]
  hideEODSearch?: boolean
  equalizeTicker?: boolean
  title?: string
}
const props = defineProps<Props>()

const dialogTitle = computed(() =>
  props.title || (props.modal.entity.isNew ? ASSET_MODAL_TITLE_NEW : ASSET_MODAL_TITLE),
)

const isOpen = computed(() => props.modal.isOpened)

const zIndex = computed(() => props.modal.zIndex)

provide('restrictions', props.restrictions)

const handleClose = () => {
  props.modal.conditionalClose()
}
</script>
